import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  changeLanguage,
  initializeSectionsForPrinting,
  setPromotionSlug,
  setPublic,
} from '../../model/configuratorSlice';
import SummarySectionsListPrinting from './SummarySectionsListPrinting';
import { ClientBaseUrl, Language } from '../../model/constants';
import GenerationService from '../../services/GenerationService';
import BudgetStatus from './Component/BudgetStatus';
import ToBoolean from '../../utils/BooleanUtils';
import { TranslationUtility } from '../../utilities/TranslationUtility';
import IsNullOrUndefined from '../../utils/ObjectUtils';

const SummaryPanelPrinting = () => {
  const { promotionSlug, code } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const {
   isLoading, currentUnit, currentConfigCode, settings, unitUsers, printingShots, legalSettings, vat,
  } = useSelector(state => state.configurator);

  const generationMutation = GenerationService();

  const [firstShot, setFirstShot] = useState(null);
  const [secondShot, setSecondShot] = useState(null);
  const [thirdShot, setThirdShot] = useState(null);
  const [fourthShot, setFourthShot] = useState(null);
  const [fifthShot, setFifthShot] = useState(null);

  const [isGenerationMutationCallMade, setIsGenerationMutationCallMade] = useState(false);

  const dispatch = useDispatch();

  dispatch(setPromotionSlug(promotionSlug));

  const includesPrices = ToBoolean(searchParams.get('includes-prices'));
  const unitId = searchParams.get('unit-id');
  const downloadToken = searchParams.get('download-token');
  const requestBudgetToken = searchParams.get('request-budget-token');
  const language = searchParams.get('language');
  const isPublic = ToBoolean(searchParams.get('is-public'));

  dispatch(setPublic(isPublic));

  const isRequestBudget = requestBudgetToken != null;
  const linkUrl = `${ClientBaseUrl}/${promotionSlug}/${code}`;

  useEffect(() => {
    generationMutation.mutate({
      promotion_slug: promotionSlug,
      id_units: unitId,
      code,
      isPublic,
    });
    setIsGenerationMutationCallMade(true);
  }, []);

  useEffect(() => {
    if (currentConfigCode === code) {
      dispatch(changeLanguage(language));
      dispatch(initializeSectionsForPrinting());
    }
  }, [currentConfigCode]);

  useEffect(() => {
    if (printingShots !== null) {
      setFirstShot(printingShots[3]);
      setSecondShot(printingShots[0]);
      setThirdShot(printingShots[2]);
      setFourthShot(printingShots[4]);
      setFifthShot(printingShots[1]);
    }
  }, [printingShots]);

  useEffect(() => {
  }, [isLoading]);

  if (isLoading || (isRequestBudget && unitUsers === null)) {
    return 'Loading...';
    // eslint-disable-next-line max-len
    // return `isGenerationMutationCallMade: ${isGenerationMutationCallMade}, isRequestBudget: ${isRequestBudget}, settings: ${settings}, currentUnit: ${currentUnit}, unitUsers: ${unitUsers}`;
  }

  document.body.style.overflowY = 'visible';
  document.body.style.backgroundColor = 'white';

  return (
    <div className="summary-panel-printing">
      <div className="summary-content">
        <div className="top-images-container">
          <div className="image-printing-summary">
            <img src={`${settings.shots_base_url}/${firstShot}.jpg`} alt="" />
          </div>
          <div className="image-printing-summary large">
            <img src={`${settings.shots_base_url}/${secondShot}.jpg`} alt="" />
          </div>
        </div>
        <div className="middle-images-container">
          <div className="image-printing-summary large">
            <img src={`${settings.shots_base_url}/${thirdShot}.jpg`} alt="" />
          </div>
          <div className="client-promotion-square-summary">
            <div className="client-logo">
              {/* <img
                src={`${process.env.PUBLIC_URL}/img/bizionar_summary.png`}
                alt=""
              /> */}
              <img
                src={`${process.env.PUBLIC_URL}/promotion/${promotionSlug}.png`}
                alt=""
              />
            </div>
            {/* <div className="client-promotion-container">
              <div className="promotion">{settings.name}</div>
            </div> */}
          </div>
        </div>
        <div className="bottom-images-container">
          <div className="image-printing-summary">
            <img src={`${settings.shots_base_url}/${fourthShot}.jpg`} alt="" />
          </div>
          <div className="image-printing-summary large">
            <img src={`${settings.shots_base_url}/${fifthShot}.jpg`} alt="" />
          </div>
        </div>
        <div className="data-container">
          <div className="user-data">
            <div className="title">
              {TranslationUtility.GetFormattedMessageForUI('ui-printing-summary-title', 'Datos')}
            </div>
            <div className="date">
              {TranslationUtility.GetFormattedMessageForUI('ui-printing-summary-date', 'Fecha:')}
              <span>{new Date(Date.now()).toLocaleString('es-ES').split(',')[0]}</span>
            </div>
            {/* eslint-disable-next-line max-len */}
            {currentUnit != null ? <div className="flat">{TranslationUtility.GetFormattedMessageForUI('ui-printing-summary-unit', 'Vivienda:')}<span>{currentUnit.name}</span></div> : null}
            {/* eslint-disable-next-line max-len */}
            {currentUnit != null ? <div className="flat">{TranslationUtility.GetFormattedMessageForUI('ui-printing-summary-typology', 'Tipología:')} <span>{currentUnit.typology}</span></div> : null}
            <div className="typology"><span /></div>
            <div className="date"><span /></div>
            <div className="divider" />
          </div>

          {isPublic ? (
            <div className="configuration-data">
              <div className="title">
                {TranslationUtility.GetFormattedMessageForUI('ui-printing-summary-your-configuration',
                    'Su configuración')}
              </div>
              <div className="subtitle">
                <span>
                  {TranslationUtility.GetFormattedMessageForUI('ui-printing-summary-public-text-1',
                        'A continuación se muestra un resumen con las imágenes y el listado')}
                  <br />
                  {TranslationUtility.GetFormattedMessageForUI('ui-printing-summary-public-text-2',
                        'de opciones elegidas por usted para su futura vivienda.')}
                </span>
              </div>
              <div className="container-qr-text">
                <div className="code-title">
                  <span>
                    {TranslationUtility.GetFormattedMessageForUI('ui-printing-summary-configuration-code',
                      'Código de configuración')}
                  </span>
                </div>
                <div className="code">{code}</div>
              </div>
            </div>
        ) : (
          <div className="configuration-data">
            <div className="title">
              {TranslationUtility.GetFormattedMessageForUI('ui-printing-summary-your-configuration',
                    'Su configuración')}
            </div>
            <div className="subtitle">
              <span>
                {TranslationUtility.GetFormattedMessageForUI('ui-printing-summary-come-back-text-1',
                        'Vuelve rápidamente a esta configuración con este código personalizado')}
                <br />
                {TranslationUtility.GetFormattedMessageForUI('ui-printing-summary-come-back-text-2',
                        'que puedes cargar desde el menú del configurador.')}
              </span>
            </div>
            <div className="container-qr-text">
              <div className="code-title">
                <span>
                  {TranslationUtility.GetFormattedMessageForUI('ui-printing-summary-configuration-code',
                          'Código de configuración')}
                </span>
              </div>
              <div className="code">{code}</div>
              {(!isRequestBudget || includesPrices) ? (
                <div className="link">
                  <a href={linkUrl}>
                    <span>{linkUrl}</span>
                  </a>
                </div>
                ) : null}
            </div>
          </div>
        )}
        </div>

        <div className="bottom-line-container">
          <BudgetStatus isRequestBudget={isRequestBudget} includesPrices={includesPrices} />
        </div>
        <div className="legal-base-text" />
        <div className="sections-list-container">
          <SummarySectionsListPrinting includesPrices={includesPrices && vat.public_prices_enabled !== false} />
        </div>
        {(isRequestBudget && includesPrices) ? (
          <div className="container-claim-signatures">
            <div className="claim" />
            <div className="container-habitat-signature">
              <div className="name"><p>Culmia Desarrollos Inmobiliarios, S.L.U.</p></div>
              <div className="signature-field">
                <div className="title">
                  {TranslationUtility.GetFormattedMessageForUI('ui-printing-summary-signature', 'Firma:')}
                </div>
                <div className="signature-box" />
              </div>
            </div>
            <div className="container-users-signatures">
              {unitUsers.users.map((unitUser, index) => (
                <div className="container-user-signature">
                  <div className="name"><p>{unitUser.name}</p></div>
                  <div className="signature-field">
                    <div className="title">
                      {TranslationUtility.GetFormattedMessageForUI('ui-printing-summary-signature', 'Firma:')}
                    </div>
                    <div className="signature-box" />
                  </div>
                </div>
                ))}
            </div>
          </div>
        ) : null}
        {(isRequestBudget && !includesPrices) ? null : (
          <div className="summary-disclaimer-container">
            <div className="summary-disclaimer-title">
              {TranslationUtility.GetFormattedMessageForUI('ui-printing-summary-disclaimer-title',
                    'CONDICIONES APLICABLES')}
            </div>
            <div className="summary-disclaimer-text">
              {TranslationUtility.GetFormattedMessageForUI('ui-printing-summary-disclaimer-text-6',
                  legalSettings.summaryDisclaimerText6)}
            </div>
            <div className="summary-disclaimer-text">
              {/* TranslationUtility.GetFormattedMessageForUI('ui-printing-summary-disclaimer-text-2',
                  legalSettings.summaryDisclaimerText2) */}
            </div>
            <div className="summary-disclaimer-text">
              {/* TranslationUtility.GetFormattedMessageForUI('ui-printing-summary-disclaimer-text-3',
                  legalSettings.summaryDisclaimerText3) */}
            </div>
            <div className="summary-disclaimer-text">
              {/* TranslationUtility.GetFormattedMessageForUI('ui-printing-summary-disclaimer-text-4',
                  legalSettings.summaryDisclaimerText4) */}
            </div>
            <div className="summary-disclaimer-text">
              {/* TranslationUtility.GetFormattedMessageForUI('ui-printing-summary-disclaimer-text-5',
                  legalSettings.summaryDisclaimerText5) */}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

        export default SummaryPanelPrinting;
